module.exports = __webpack_public_path__ + "static/media/ic_signature.e2dda56f.svg";